import { requests, ResponseType } from '../core';
import type { CategoryResponse } from './types';

/**
 * 카테고리 목록 조회 API
 * Swagger: https://api-dev.acepharm.co.kr/swagger-ui/index.html#/[사용자,관리자]%20카테고리%20조회%20API/getCategoryList
 */
export const categoryApi = {
  /**
   * 전체 카테고리 목록 조회 (3단 계층 구조)
   * GET /api/category
   * @returns 대분류/중분류/소분류 계층 구조의 카테고리 목록
   */
  getCategoryList: async (): Promise<ResponseType<CategoryResponse[]>> => {
    return await requests.get<CategoryResponse[]>('/api/category', false);
  },
};

// 타입 재내보내기
export type { CategoryResponse, CategoryItem, CategoryType } from './types';

export const fetchCategoryList = async (): Promise<CategoryResponse[]> => {
  const response = await categoryApi.getCategoryList();

  if (response.isSuccess && Array.isArray(response.result)) {
    return response.result;
  }

  throw new Error(response.message ?? '카테고리 목록 조회에 실패했습니다.');
};
